import { render } from "./TokenExpirationTimer.vue?vue&type=template&id=f917a50e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TokenExpirationTimer.vue?vue&type=script&lang=js"
export * from "./TokenExpirationTimer.vue?vue&type=script&lang=js"

import "./TokenExpirationTimer.vue?vue&type=style&index=0&id=f917a50e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f917a50e"]])

export default __exports__